import { withMemberContext } from '@/config/site'
import request from '@/utils/request'

export const createMemberGroup = async (payload = {}) => {
  const response = await request('/page/group/create', {
    data: withMemberContext(payload)
  })

  return response.data || {}
}

export const fetchMyMemberGroups = async (payload = {}) => {
  const response = await request('/page/group/my', {
    data: withMemberContext(payload)
  })

  return Array.isArray(response.data) ? response.data : []
}

export const fetchMemberGroupMembers = async (groupId, payload = {}) => {
  const response = await request('/page/group/members', {
    data: withMemberContext({
      group_id: groupId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}

export const fetchMemberGroupMessages = async (groupId, payload = {}) => {
  const response = await request('/page/group/messages', {
    data: withMemberContext({
      group_id: groupId,
      ...payload
    })
  })

  const data = response.data || {}
  if (Array.isArray(data)) {
    return {
      list: data,
      total: data.length,
      page: payload.page || 1,
      page_size: payload.page_size || data.length
    }
  }

  return {
    list: Array.isArray(data.list) ? data.list : [],
    total: Number(data.total) || 0,
    page: Number(data.page) || Number(payload.page) || 1,
    page_size: Number(data.page_size) || Number(payload.page_size) || 20
  }
}

export const sendMemberGroupMessage = async (groupId, content, payload = {}) => {
  const response = await request('/page/group/send-message', {
    data: withMemberContext({
      group_id: groupId,
      content,
      ...payload
    })
  })

  return response.data || {}
}
